import {closeSnackbar} from "notistack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {DELIVERY_PENDING, DELIVERY_WAITING} from "./shareDelivery";

/**
 * The snackbar options for the message after sharing (DE-1656). The sent message hides itself as other messages do.
 * The waiting message, and the pending one (DE-1723), tell the sharer something they need, so they stay until closed.
 */
export const shareDeliverySnackbarOptions = (t, delivery) => {
    if (delivery === DELIVERY_WAITING) return _persistent(t, 'success');
    if (delivery === DELIVERY_PENDING) return _persistent(t, 'info');
    return {variant: 'success'};
};

const _persistent = (t, variant) => ({
    variant,
    persist: true,
    action: key => <IconButton size="small" color="inherit" onClick={() => closeSnackbar(key)}
                               aria-label={t('closeMessage', 'Lukk melding')}>
        <CloseIcon fontSize="small"/>
    </IconButton>,
});
